/*
const data1 = {
  data: {
    simpleQuestions: [
      {
        question: "whos is who",
        answer: "dsa",
        _id: "66686d73b975d1d30f1220ca",
      },
      {
        question: "its a new question",
        answer: "dsa",
        _id: "66686d73b975d1d30f1220cb",
      },
      {
        question: "remark",
        answer: "thankyou",
        _id: "66686d73b975d1d30f1220cc",
      },
    ],
    optionQuestions: [
      {
        question: "this is first option question",
        answer: "option 1",
        _id: "66686d73b975d1d30f1220cd",
      },
      {
        question: "this is second option question",
        answer: "option 1",
        _id: "66686d73b975d1d30f1220ce",
      },
      {
        question: "this is third option question",
        answer: "option 1",
        _id: "66686d73b975d1d30f1220cf",
      },
    ],
    checkQuestions: [],
  },
  _id: "66686d73b975d1d30f1220c9",
  admin_id: "6666b64698d6ffd02df1974b",
  rating: 4,
  createdAt: "2024-06-11T15:29:55.067Z",
  updatedAt: "2024-06-11T15:29:55.067Z",
  __v: 0,
};
*/

export default function ratingFilteration(data, rating) {
  // this function return an object data with rating match
  // console.log("filteration");
  //console.log(rating);
  //console.log(data);
  let sign = rating[1];
  // below we are creating a copy of data object to manipulate/change.
  let mainData = JSON.parse(JSON.stringify(data));
  //console.log(mainData);
  let resultData;
  //console.log(rating);
  let myRating = +rating[0];
  // checking if rating is ALL ie 5 and below 5- then return data as it is

  if (rating == "5-") return mainData;

  if (sign === "*") {
    resultData = mainData.filter((item) => {
      if (item.rating == myRating) return true;
    });
  }
  if (sign === "+") {
    resultData = mainData.filter((item) => {
      if (item.rating >= myRating) return true;
    });
  }
  if (sign === "-") {
    resultData = mainData.filter((item) => {
      if (item.rating <= myRating) return true;
    });
  }
  //console.log(resultData);
  return resultData;
}
